import { CustomerUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

type NaturalitiesModel = {
  id: string | number
  name: string
}

export const fetchListNationalities = () => {
  return new CustomerUseCase(
    '/clientes/load/nationalities',
    makeAxiosHttpClient()
  )
}

export const fetchListNaturalities = ({ id, name }: NaturalitiesModel) => {
  return new CustomerUseCase(
    `/clientes/load/naturalities/${id}?nome=${name}`,
    makeAxiosHttpClient()
  )
}

export const fetchListMaritalStatus = () => {
  return new CustomerUseCase(
    '/clientes/load/estadosCivis',
    makeAxiosHttpClient()
  )
}

export const fetchListSchooling = () => {
  return new CustomerUseCase(
    '/clientes/load/escolaridades',
    makeAxiosHttpClient()
  )
}

export const fetchListDocuments = () => {
  return new CustomerUseCase(
    '/clientes/load/tiposDocumentos',
    makeAxiosHttpClient()
  )
}
